import React from 'react';
import { Tag, Typography } from 'antd';
import { WarehousePackageRow } from '../../api/warehouse';
import { money, num } from './format';

const { Text } = Typography;

// withSpacer — широкая развёртка списка: фикс-ширины слева + распорка, правая
// группа у края. Без распорки (карточка, ~512px) — авто-раскладка без фикс-ширин,
// иначе сумма фикс-ширин (610px) не влезает и карточка ложно дооткрывается.
export const packageColumns = (showInactiveTag: boolean, withSpacer: boolean) => [
  { title: 'Артикул', dataIndex: 'article', key: 'article', ...(withSpacer ? { width: 130 } : {}), render: (v: string | null) => v || '—' },
  {
    title: 'Фасовка', dataIndex: 'package_label', key: 'package_label', ...(withSpacer ? { width: 120 } : {}),
    render: (v: string, p: WarehousePackageRow) => (
      <span style={{ whiteSpace: 'nowrap' }}>
        {v}
        {showInactiveTag && p.inactive && <div><Tag>нет на складе</Tag></div>}
      </span>
    ),
  },
  ...(withSpacer ? [{ title: '', key: 'spacer' }] : []),
  { title: 'Закупка', dataIndex: 'purchase_price', key: 'purchase_price', align: 'right' as const, width: 90, render: (v: number | null) => <span style={{ whiteSpace: 'nowrap' }}>{money(v)}</span> },
  { title: 'Цена', dataIndex: 'sale_price', key: 'sale_price', align: 'right' as const, width: 90, render: (v: number | null) => <span style={{ whiteSpace: 'nowrap' }}>{money(v)}</span> },
  {
    title: 'Доступно', dataIndex: 'available', key: 'available', align: 'right' as const, width: 100,
    render: (v: number | null, p: WarehousePackageRow) => v == null
      ? <Text type="secondary">нет</Text>
      : (
        <span style={{ fontWeight: 600, whiteSpace: 'nowrap', color: Number(v) <= 0 ? '#cf1322' : undefined }}>
          {num(v)} {p.unit == null ? 'л' : 'шт'}
        </span>
      ),
  },
];
